export const EDIT_ORG_NOTES_MODAL_NAME = 'EDIT_ORG_NOTES_MODAL_NAME';
